module.exports = __webpack_public_path__ + "img/trash-restore.51255dd8.svg";